<script>
  import {onMount} from 'svelte';
  import Brandkit from './BrandKit.svelte';
  import BrandkitDescription from './BrandkitDescription.svelte';
  import {events} from '../../utils/custom-event-names';
  // onMount(() => {
  //     window.dispatchEvent(new Event(events.openSideNav));
  // })
</script>

<div class="flex h-full min-h-full w-full items-start space-x-3 overflow-y-scroll bg-gray-200 p-4">
  <div class="flex-grow rounded-xl bg-white p-8 shadow-md">
    <Brandkit />
  </div>
  <div class="rounded-xl bg-white p-8 shadow-md">
    <BrandkitDescription />
  </div>
</div>
